














































import { Vue, Component } from 'vue-property-decorator'
import validation from '@/common/element-val'
import { ElForm } from 'element-ui/types/form'
import settingService from '../../services/settingService'
import { MessageText } from '@/services/data'
import Msg from '@/components/Msg.vue'
import utility from '@/common/utility'

@Component({
  computed: {
    utility () {
      return utility
    }
  },
  components: {
    Msg
  }
})
export default class Mail extends Vue {
  $refs: {
    accForm: ElForm;
  }

  vm = {
    Coins: [] as Array<string>
  }

  rules = {
    AccountName: validation.requiredRule(),
    Key: validation.requiredRule(),
    Secret: validation.requiredRule()
  }

  message: MessageText = null
  async mounted () {
    await this.load()
  }

  async load () {
    const res = await settingService.readUserSettingsByNamesAsync(['BalancesAssets'])
    const result = res.Result
    if (result) {
      this.vm.Coins = this.parseJson(result, 'BalancesAssets') ?? ['USDT', 'USDC', 'BTC', 'ETH', 'SOL', 'DOGE']
    }
  }

  parseJson (items: Array<{ Name: string; Value: string }>, name: string): any {
    const item = items.find(p => p.Name === name)
    if (item) {
      return JSON.parse(item.Value)
    }
    return null
  }

  async submit () {
    if (this.vm.Coins.length > 0) {
      const res = await settingService.addOrUpdateUserSettingAsync([{ Name: 'BalancesAssets', Value: JSON.stringify(this.vm.Coins), ValueType: 'Json' }])
      if (res.Result) {
        this.message = { success: this.$t('msg.settingSaved') as string }
      } else {
        this.message = { error: this.$t('msg.unableToSave') as string }
      }
    } else {
      this.message = { error: this.$t('val.required') as string }
    }
  }
}
